import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

import './InternalFooterView.css';
import tmplInternalFooterView from './InternalFooterView.hbs';

const InternalFooterView = View.extend({
  template: tmplInternalFooterView,

  className: 'internal-footer-view collapse bg-primary',

  tagName: 'footer',

  onRender() {
    Radio.channel('footer').on('show:internal', () => {
      this.$el.removeClass('collapse');
    });

    Radio.channel('footer').on('hide:footer', () => {
      this.$el.addClass('collapse');
    });
  }
});

export default InternalFooterView;
